import React, { useState } from "react";

import i18n from "./translation/i18n";
import { I18nextProvider } from "react-i18next";
import MyContext from "./context.js";
import { ConfigProvider } from 'antd';

// Containers
const Layout = React.lazy(() => import("./layout.js"));

const App = () => {
  const [breadcrumbName, setBreadcrumbName] = useState("");
  const [imgAdsProduct, setImgAdsProduct] = useState();
  return (
    <React.Fragment>
      <MyContext.Provider value={{
        breadcrumbName, setBreadcrumbName,
        imgAdsProduct, setImgAdsProduct
      }}>
        <I18nextProvider i18n={i18n}>
          <ConfigProvider theme={{ hashed: false }}>
            <Layout />
          </ConfigProvider>
        </I18nextProvider>
      </MyContext.Provider>
    </React.Fragment>
  );
};

export default App;
